/* Copyright 2021 VMware, Inc. All rights reserved. VMware Confidential */
import { Component, OnDestroy } from "@angular/core";
import { AppStateService } from "@app/services/app-state/app-state.service";

// @formatter:off
@Component({
  selector: 'app-error404',
  templateUrl: './error404.component.html'
})
// @formatter:on
export class Error404Component implements OnDestroy {

    constructor(public appStateService: AppStateService) {
        this.appStateService.isError404 = true;
    }

    ngOnDestroy(): void {
        this.appStateService.isError404 = false;
    }

}
